module.exports = __webpack_public_path__ + "img/Team-Wilde-Pracht-740.9c07ffa7.jpg";